/* eslint-disable */

export const fotmatPercent = (value) => Math.round(value) + "%"

export const progressRound = (value) => {
  if (value === 0) {
    return 0
  } else if (value <= 1) {
    return 1
  } else if (value >= 100) {
    return 100
  } else {
    return Math.floor(value)
  }
}
